module.exports = __webpack_public_path__ + "static/Grand-Theatre-89c3c914483684f4762626994262629c.jpg";